module.exports = __webpack_public_path__ + "static/media/OpenDyslexic-Bold.e3c427f3.otf";